import { __rest } from "tslib";
import { getIn18Text } from 'api';
import React, { useEffect } from 'react';
import { ResizableBox } from 'react-resizable';
import classname from 'classnames';
import 'react-resizable/css/styles.css';
import { apiHolder, apis, api } from 'api';
import { CollapsibleList } from '@web-common/components/UI/CollapsibleList';
import styles from './main.module.scss';
const systemApi = api.getSystemApi();
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const SideContentLayout = React.forwardRef((props, ref) => {
    const { defaultWidth = 200, defaultheight = '100%', children, minConstraints = [100, 0], maxConstraints = [500, Infinity], resizeClassName = '', onResize, onResizeStart, onResizeStop, className, component, minWidth, maxWidth, style, innerStyle, forbidGridWeb = false, borderRight, fixedWidth, needBtn = false } = props, rest = __rest(props, ["defaultWidth", "defaultheight", "children", "minConstraints", "maxConstraints", "resizeClassName", "onResize", "onResizeStart", "onResizeStop", "className", "component", "minWidth", "maxWidth", "style", "innerStyle", "forbidGridWeb", "borderRight", "fixedWidth", "needBtn"]);
    if (minWidth !== undefined) {
        minConstraints[0] = minWidth;
    }
    if (maxWidth !== undefined) {
        maxConstraints[0] = maxWidth;
    }
    const [height, setHeight] = React.useState(defaultheight);
    const [width, setWidth] = React.useState(defaultWidth);
    const handleResize = (_, data) => {
        const { size: { width, height }, } = data;
        setWidth(width);
        setHeight(height);
        if (onResize) {
            onResize(_, data);
        }
    };
    const componentProps = {
        className: classname([styles.sideContentLayoutWarpper, className || ''], {
            [styles.borderRight]: borderRight,
        }),
        children,
        ref,
    };
    useEffect(() => {
        if (defaultWidth !== width) {
            setWidth(defaultWidth);
        }
    }, [defaultWidth]);
    const handleOnResizeStop = (e, data) => {
        onResizeStop && onResizeStop(e, data);
    };
    const handleOnResizeStart = (e, data) => {
        onResizeStart && onResizeStart(e, data);
    };
    useEffect(() => {
        rest.height && setHeight(rest.height);
    }, [rest.height]);
    if (fixedWidth) {
        return (React.createElement("div", { style: Object.assign(Object.assign({}, style), { width: fixedWidth, height: '100%', backgroundColor: '#F9FAFC' }) }, React.createElement(component || 'div', componentProps)));
    }
    return (React.createElement(CollapsibleList, { title: getIn18Text('WENJIANJIA'), style: Object.assign({ width,
            height }, style), innerStyle: innerStyle, onChange: (width, height) => {
            const context = {};
            const data = {
                size: {
                    width,
                    height,
                },
            };
            onResize && onResize(context, data);
        }, needBtn: needBtn, onOpen: () => {
            trackApi === null || trackApi === void 0 ? void 0 : trackApi.track('pcMail_click_open_sidebar_mailfolder');
        }, onClose: () => {
            trackApi === null || trackApi === void 0 ? void 0 : trackApi.track('pcMail_click_close_sidebar_mailfolder');
        } },
        React.createElement(ResizableBox, Object.assign({ className: classname(['sirius-middle-grid', resizeClassName], {
                'sirius-middle-grid-web': systemApi.isWebWmEntry() && !forbidGridWeb,
            }), maxConstraints: maxConstraints, onResize: handleResize, width: typeof defaultWidth === 'string' ? Infinity : defaultWidth, height: Infinity, minConstraints: minConstraints, onResizeStart: handleOnResizeStart, onResizeStop: handleOnResizeStop, axis: "x" }, rest), React.createElement(component || 'div', componentProps))));
});
export default SideContentLayout;
